<template>
  <div class="address-cascader">
    <el-cascader v-model="selectedAddress" style="width: 60%;" :options="addressOption" :props="cascaderProps"
      :placeholder="placeholder" :collapse-tags="true" :show-all-levels="showAllLevels" @change="handleChange" />
  </div>
</template>

<script>
import { getProvinceList, getCityList, getRegionList } from '@/api/basic/basic.js' // 根据实际路径调整

export default {
  name: 'AddressCascader',

  props: {
    // v-model绑定值
    value: {
      type: Array,
      default: () => []
    },
    // 占位提示
    placeholder: {
      type: String,
      default: '请选择省/市/区'
    },
    // 是否显示完整路径
    showAllLevels: {
      type: Boolean,
      default: true
    },
    // 多选时是否折叠Tag
    collapseTags: {
      type: Boolean,
      default: false
    },
    // 是否在下方显示选中地址
    showAddress: {
      type: Boolean,
      default: true
    },
    // 是否只返回编码，不返回名称
    returnCodeOnly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedAddress: [['1', '1'], ['2', '2']],
      mdList: [],
      addressMap: new Map(), // 存储编码对应的名称
      addressOption: [],
      cascaderProps: {
        multiple: true,
        children: 'children',
        leaf: 'leaf',
        checkStrictly: false,
        emitPath: true // 返回完整路径
      }
    }
  },

  computed: {
    // 获取选中的地址文本
    selectedAddressText() {
      if (!this.selectedAddress.length) return ''

      // 从Map中获取名称
      const names = this.selectedAddress.map(code => {
        return this.addressMap.get(code) || code
      })

      return names.join(this.separator)
    }
  },

  watch: {
    value: {
      handler(newVal) {
        console.log(newVal);
        this.selectedAddress = newVal || []
      },
      immediate: true
    }
  },
  mounted() {
    this.loadAddress();
  },
  methods: {
    async loadAddress() {
      let list = await this.loadProvinces();
      list.forEach(async (item, index) => {
        let data = await this.loadCities(item.value);
        this.$set(item, "children", data)
        // item.children.push(data);
      });
      this.addressOption = list;
      this.selectedAddress = this.mdList;
    },

    // 加载省份列表
    async loadProvinces() {
      const res = await getProvinceList();
      return res.map(province => ({
        value: province.province_code,
        label: province.province_name,
        children: [],
        leaf: false // 省份不是叶子节点，还有城市
      }))
    },

    // 加载城市列表
    async loadCities(provinceCode) {
      const res = await getCityList(provinceCode);
      let list = [];
      if (res.data.resp_data.length > 0) {
        list = res.data.resp_data;
      }
      return list.map(city => ({
        value: city.city_code,
        label: city.city_name,
        leaf: true // 城市不是叶子节点，还有区县
      }))
    },

    // 加载区县列表
    async loadRegions(provinceCode, cityCode) {
      const res = await getRegionList(provinceCode, cityCode);
      let list = [];
      if (res.data.resp_data.length > 0) {
        list = res.data.resp_data;
      }
      return list.map(region => ({
        value: region.region_code,
        label: region.region_name,
        leaf: true // 区县是叶子节点
      }));
    },

    // 处理选中变化
    handleChange(value) {
      this.selectedAddress = value;
      if (this.returnCodeOnly) {
        // 只返回编码
        this.$emit('input', value)
        this.$emit('change', value, this.getAddressNames(value))
      } else {
        // 返回完整信息
        const addressInfo = this.getAddressInfo(value)
        this.$emit('input', addressInfo)
        this.$emit('change', addressInfo, this.selectedAddressText)
      }
    },

    // 获取地址完整信息
    getAddressInfo(codes) {
      if (!codes || !codes.length) return null
      try {
        return {
          codes: codes,
          names: codes.map(code => this.addressMap.get(code)),
          text: codes.map(code => this.addressMap.get(code)).join(this.separator)
        }
      } catch (e) {
        console.log(e)
      }
    },
    getAddress() {
      return this.selectedAddress;
    },
    // 获取地址名称数组
    getAddressNames(codes) {
      return codes.map(code => this.addressMap.get(code))
    },
    // 根据编码设置选中值
    setValueByCodes(codes) {
      if (!codes) {
        return;
      }
      this.mdList = JSON.parse(codes).map(item => {
        return [item.slice(0, 2).padEnd(12, '0'), item]
      });
    }
  }
}
</script>

<style scoped>
.address-cascader {
  width: 100%;
}

.selected-address {
  margin-top: 8px;
  font-size: 14px;
  color: #606266;
  padding: 5px 0;
}

/* 自定义级联选择器宽度 */
:deep(.el-cascader) {
  width: 100%;
}

/* 调整下拉菜单宽度 */
:deep(.el-cascader-menu) {
  min-width: 160px;
}

/* 加载状态样式 */
:deep(.el-cascader-node.in-active-path) {
  font-weight: 500;
}
</style>